import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Utils from '../../../Services/Utils';

import { FormContext } from '../../../Context/FormContext';
import Checkbox from '../Checkbox';
import ConfigService from "../../../Services/api/Config";

class CheckboxWrapper extends React.PureComponent {
  static contextType = FormContext;

  componentDidMount() {
    this.initValidate();
  }

  componentDidUpdate() {
    this.initValidate();
  }

  initValidate = () => {
    const { value, onError, error } = this.props;
    const newError = this.validate(value);
    if (onError && !Utils.equals(newError, error)) onError(newError);
  }

  validate = (value) => {
    const { required, validators } = this.props;
    if (required && Utils.isEmpty(value)) return 'This field is required.';
    for (const validator of validators || []) {
      if (validator(value)) return validator(value);
    }
    return '';
  };

  handleChange = (v) => {
    const { onChange, onError, error, value } = this.props;
    const newVal = v;
    let result = null;
    if (!Utils.isNull(value)) {
      result = (Array.isArray(value) ? this.getValidValues(value) : value.split(','));
    }
    else {
      result = [];
    }
    if (result.includes(newVal)) {
      result.splice(result.indexOf(newVal), 1);
    }
    else {
      result.push(newVal);
    }
    if (onChange) onChange(result.join(','));
    const newError = this.validate(result.join(','));
    if (onError && !Utils.equals(newError, error)) onError(newError);
  };

  getValidValues = (value) => {
    let results = [];
    value.map((item) => {
      if (!Utils.isNull(item)) {
        results.push(item.toString());
      }
    });
    return results
  };

  render() {
    const {
      label,
      error,
      className,
      required,
      options,
      disabled,
      value
    } = this.props;

    let valueCheckbox = value;
    if (!Utils.isNull(value)) {
      valueCheckbox = (Array.isArray(value) ? this.getValidValues(value) : value.split(','));
    }

    const isSubmitted = this.context ? this.context.isSubmitted : false;
    return (
      <div
        className={ classNames(className, 'InputWrapper', {
          InputWrapper_Error: Boolean(error) && Boolean(isSubmitted),
        }) }
      >
        { label &&
        <div className='InputWrapper-Label'>
          { label }
          { required &&
          <span className='InputWrapper-Label-Required' style={ { color: ConfigService.getColor('errorColor') } }>*</span>
          }
        </div>
        }
        <div className='InputWrapper-Content'>
          { options.map((item, index) =>
            <Checkbox
              key={ index }
              onChange={ () => this.handleChange(item.value.toString()) }
              label={ item.label }
              checked={ !Utils.isNull(valueCheckbox) && valueCheckbox.includes(item.value.toString()) }
              help={ item.help }
              disabled={ disabled }
              className={ className }
            />
          ) }
        </div>
        { (error && isSubmitted) && (
          <div className='InputWrapper-Error' style={ { color: ConfigService.getColor('errorColor') } }>
            { error }
          </div>
        ) }
      </div>
    );
  }
}


CheckboxWrapper.propTypes = {
  label: PropTypes.string,
  children: PropTypes.node,
  error: PropTypes.string,
  className: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  isSubmitted: PropTypes.bool,
};

export default CheckboxWrapper;